import {createDivIn, createHeaderIn, createImgIn, createUnorderedListIn, createListItemIn, createParagraphIn, setElementInnerHTML} from '../../../shared/scripts/ui_utils/DomUtils'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {UIImagePathController} from '../../../shared/scripts/UIEnums.ts'
import {LobbyImage} from '@colonist/types'
import {RankedDivisionTypes} from '../../../../shared/leaderboard_data/LeaderboardEnums'
import {clientI18n} from '../../../shared/scripts/ClientI18n'
import {TranslationObject} from '@colonist/i18n'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'

export class ViewPopupRankedGameDescription extends ViewPopup {
    private readonly leagueIconSection: HTMLDivElement
    private readonly descriptionSection: HTMLDivElement
    private readonly faqSection: HTMLDivElement
    constructor() {
        super({key: 'strings:homePage.ranked.infoPopup.title'}, {key: 'strings:colonistCommon.utils.emptyString'}, () => undefined, () => undefined, true)

        this.body.style.flexDirection = 'column'
        setElementInnerHTML(this.body, {key: 'strings:colonistCommon.utils.emptyString'})

        this.leagueIconSection = createDivIn(this.body, 'popup_ranked_game_description_league_icons', '')
        this.descriptionSection = createDivIn(this.body, 'popup_ranked_game_description_texts_wrapper', '')
        this.faqSection = createDivIn(this.body, 'popup_ranked_game_description_faq', '')
        this.leagueIconSection.style.display = 'flex'

        const rankedDivisionImages: LobbyImage[] = [
            UIImagePathController.getRankedDivisionImage(RankedDivisionTypes.Bronze),
            UIImagePathController.getRankedDivisionImage(RankedDivisionTypes.Silver),
            UIImagePathController.getRankedDivisionImage(RankedDivisionTypes.Gold),
            UIImagePathController.getRankedDivisionImage(RankedDivisionTypes.Platinum),
            UIImagePathController.getRankedDivisionImage(RankedDivisionTypes.Diamond),
        ]

        if(rankedDivisionImages.length !== 0) {
            for(const img of rankedDivisionImages) {
                const imageElement = createImgIn(this.leagueIconSection, img)
                imageElement.style.width = (100 / rankedDivisionImages.length) + '%'
            }
        }

        const context = UIUtilsEjsVariables.isUserOnDiscord ? 'discord' : ''
        const howItWorksItems = clientI18n.tArray('strings:homePage.ranked.infoPopup.howItWorks.description', {
            subscribeUrl: '/store#membership',
            leaderboardsUrl: '/leaderboards',
            context: context,
        })
        const howToPlayItems = clientI18n.tArray('strings:homePage.ranked.infoPopup.gameSettings.description')

        this.createListWithHeaderAndItems({key: 'strings:homePage.ranked.infoPopup.howItWorks.title'}, howItWorksItems)
        this.createListWithHeaderAndItems({key: 'strings:homePage.ranked.infoPopup.gameSettings.title'}, howToPlayItems)

        const faqText: TranslationObject = {key: 'strings:homePage.ranked.infoPopup.forMoreDetailsCheckOutFAQ', options: {faqUrl: '/faq#ranked'}}
        createParagraphIn(this.faqSection, faqText, 'popup_ranked_game_description_faq')

        this.removeXButton()
        this.show()
    }

    private createListWithHeaderAndItems(header: TranslationObject, items: string[]) {
        const listWrapper = createDivIn(this.descriptionSection, 'popup_ranked_game_description_text_section', '')
        const headerDiv = createDivIn(listWrapper, '')
        createHeaderIn(headerDiv, header, '')
        const list = createUnorderedListIn(listWrapper, '')
        for(const item of items) {
            const text: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: item}}
            createListItemIn(list, text, '')
        }
    }
}
